import { RichTextEditor } from './rich-text-editor';
import { EditorSkeleton } from './editor-skeleton';
import { DocDeletedBanner } from '@/components/document-banners/doc-deleted-banner';
import { DocAccessDeniedBanner } from '@/components/document-banners/doc-access-denied-banner';
import { DocSizeBanner } from '@/components/document-banners/doc-size-banner';
import { useDocSize } from '@/lib/sync/use-doc-size';
import { usePermission } from '@/lib/sharing/components/permission-gate';

interface NulaEditorProps {
  documentId: string;
  initialContent?: string;
}

export function DocumentEditor({ documentId }: NulaEditorProps) {
  const { level } = useDocSize(documentId);
  const { loading, readOnly: noEditAccess } = usePermission(documentId);

  if (loading) {
    return <EditorSkeleton />;
  }

  const readOnly = level === 'error' || noEditAccess;

  const canEditSurfaces = !noEditAccess && level !== 'error';

  return (
    <>
      <DocAccessDeniedBanner entityId={documentId} />
      <DocDeletedBanner entityId={documentId} />
      <DocSizeBanner entityId={documentId} />
      <RichTextEditor
        entityId={documentId}
        entityKindHint="document"
        readOnly={readOnly}
        canEditSurfaces={canEditSurfaces}
      />
    </>
  );
}
